<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79.758"
    height="82.005"
    xmlns:v="https://vecta.io/nano"
  >
    <defs>
      <clipPath id="A">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-431.874 -417.187)" />
      </clipPath>
      <clipPath id="B">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-473.839 -393.565)" />
      </clipPath>
      <clipPath id="C">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-468.477 -442.351)" />
      </clipPath>
      <clipPath id="D">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-457.74 -448.817)" />
      </clipPath>
      <clipPath id="E">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-485.281 -397.689)" />
      </clipPath>
      <clipPath id="F">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-428.704 -405.685)" />
      </clipPath>
      <clipPath id="G">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-458.299 -399.098)" />
      </clipPath>
      <clipPath id="H">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-450.675 -412.071)" />
      </clipPath>
    </defs>
    <g
      stroke-width="2"
      stroke="#fff"
      fill="none"
      transform="translate(-570.272 -522.763)"
      class="B C"
    >
      <g class="D">
        <path
          d="M0 0c.291 14.84 12.412 26.781 27.321 26.781 1.237 0 2.455-.082 3.649-.242"
          transform="matrix(1.333333 0 0 -1.333333 575.8324 566.2708)"
          clip-path="url(#A)"
        />
        <path
          d="M0 0c-4.233-2.692-9.256-4.251-14.643-4.251-13.03 0-23.929 9.119-26.665 21.323"
          transform="matrix(1.333333 0 0 -1.333333 631.78547 597.7668)"
          clip-path="url(#B)"
        />
        <path
          d="M0 0c10.524-3.799 18.046-13.876 18.046-25.71a27.24 27.24 0 0 0-7.968-19.287"
          transform="matrix(1.333333 0 0 -1.333333 624.63533 532.71827)"
          clip-path="url(#C)"
        />
        <path
          d="M0 0l5.104-5.104L0-10.209"
          transform="matrix(1.333333 0 0 -1.333333 610.31987 524.0968)"
          clip-path="url(#D)"
        />
        <path
          d="M0 0l-7.107-1.267-1.266 7.107"
          transform="matrix(1.333333 0 0 -1.333333 647.04147 592.26827)"
          clip-path="url(#E)"
        />
        <path
          d="M0 0l3.366 6.386 6.386-3.367"
          transform="matrix(1.333333 0 0 -1.333333 571.60533 581.60667)"
          clip-path="url(#F)"
        />
      </g>
      <path
        d="M0 0c7.087 0 12.832 5.745 12.832 12.832S0 34.505 0 34.505-12.832 19.919-12.832 12.832-7.087 0 0 0z"
        transform="matrix(1.333333 0 0 -1.333333 611.06467 590.39)"
        clip-path="url(#G)"
      />
      <path
        d="M0 0s.443-6.71 6.773-7.533"
        transform="matrix(1.333333 0 0 -1.333333 600.89987 573.09253)"
        clip-path="url(#H)"
        class="D"
      />
    </g>
  </svg>
</template>
